import React from 'react';
import propTypes from 'prop-types';

import { StyledMainLayout } from './style';
import Header from '../../containers/Header';

const Layout = ({ children, history }) => (
  <div>
    <Header history={history} />
    <StyledMainLayout>{children}</StyledMainLayout>
  </div>
);

Layout.propTypes = {
  children: propTypes.node
};

export default Layout;
